export default __webpack_public_path__ + "static/media/logo-dark.b5af5014.png";